import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { loadUser, getUser } from 'modules/users';
import { withZones } from '../Zones';
import render from './render';

export class UserEdit extends React.Component {
  static defaultProps = {
    render,
  };

  componentDidMount () {
    const { id } = this.props;

    if (id !== 'new') {
      this.props.loadUser(id);
    }
  }

  componentDidUpdate () {
    const { user: { uuid } = {}, selectZoneByUser } = this.props;
    selectZoneByUser(uuid);
  }

  render () {
    const { render: Render, ...props } = this.props;

    return <Render {...props} />;
  }
}

const mapStateToProps = (state, { id }) => ({
  user: id === 'new'
    ? {}
    : getUser(state)(id),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  loadUser,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withZones(UserEdit));



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/UserEdit/index.js